import {put, select} from "redux-saga/effects";
import {IApplicationState} from "../../index";
import {enterDoubleChanceMode} from "../../questions/actions";

export default function* () {
    const {currentQuestionId, answers} = yield select(({ questions, game }: IApplicationState) => ({
        currentQuestionId: questions.currentQuestionId,
        answers: game.questions[questions.currentQuestionId].answers
    }));

    if (answers.length < 3)
        return false;

    yield put(enterDoubleChanceMode(currentQuestionId));

    return true;
}